export default __webpack_public_path__ + "static/media/hapticgloves_demo_image.638c4ee8.jpg";